import { Helmet } from 'react-helmet';
import { LicensesTable } from '../components/Tables/LicensesTable';

const Licenses = () => {
  return (
    <div className='table-module-container'>
      <Helmet>
        <title>Licencias</title>
      </Helmet>
      <div className='datatable'>
        <LicensesTable />
      </div>
    </div>
  );
};

export default Licenses;
